import React from 'react';
import { ProfileCompletenessTag } from './profile_completeness_tag';

const ProfileCompletenessGuidanceText = () => {
    return (
        <div className="flex">
            <div className="mb-4 text-sm mr-4 font-bold">
                At least one price for Shared room, Private room or Semi-private
                room is required to be Profile Complete for Cost / Funding
            </div>
            <div>
                <ProfileCompletenessTag isVisible={true} />
            </div>
        </div>
    );
};

export { ProfileCompletenessGuidanceText };
